import axios from "axios";

const MAIN_URL = process.env.REACT_APP_BACKEND_URL;
export const MAIN_HOST = new URL(MAIN_URL).host;
// On a customer's custom domain, public pages talk to the API on that same domain (no cookies, public routes only).
export const IS_CUSTOM_HOST = typeof window !== "undefined" && window.location.host !== MAIN_HOST && !/^localhost(:\d+)?$/.test(window.location.host);
export const BACKEND_URL = IS_CUSTOM_HOST ? window.location.origin : MAIN_URL;
export const MAIN_BACKEND_URL = MAIN_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
